Bingo.PricingPackages = {};

Bingo.PricingPackages.init = function () {
    // workaround for swiper
    if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
        const evt = document.createEvent('UIEvents');
        evt.initUIEvent('resize', true, false, window, 0);
        window.dispatchEvent(evt);
    } else {
        window.dispatchEvent(new Event('resize'));
    }

    $('.js-pricingSwiper').each(function () {
        // Set ID
        const randomString = `swiper-${Math.random().toString(36).slice(-8)}`;
        $(this).attr('id', randomString);

        const commonProperties = {
            slidesPerColumnFill: 'row',
            slidesPerColumn: $(this).data('swiper-rows'),
            allowSlideNext: true,
            allowSlidePrev: true,
            slideClass: 'swiper-slide',
            spaceBetween: 15,
        };

        // Swiper init
        new Swiper(`#${randomString} .swiper-container`, {
            ...commonProperties,
            slidesPerView: 1,
            breakpoints: {
                768: {
                    ...commonProperties,
                    slidesPerView: ($(this).data('swiper-columns') <= 3 ? $(this).data('swiper-columns') - 1 : 3),
                },
                1000: {
                    ...commonProperties,
                    slidesPerView: ($(this).data('swiper-columns') <= 4 ? $(this).data('swiper-columns') - 1 : 3),
                },
                1200: {
                    ...commonProperties,
                    slideClass: 'swiper-slide-lg',
                    spaceBetween: 20,
                    slidesPerView: $(this).data('swiper-columns'),
                    allowSlideNext: false,
                    allowSlidePrev: false,
                },
            },
            on: {
                sliderMove() {
                    $('[data-toggle="tooltip"]').tooltip('hide');
                },
            },
        });

        $(this).show();
    });
};
